import { useEffect, useMemo, useState } from 'react'
import { Table } from '../../../../../components/Table'
import {
  Typography,
  TYPOGRAPHY_WEIGHT
} from '../../../../../components/Typography'
import { Button, BUTTON_TYPES } from '../../../../../components/Button'
import { formatTableData, getRowClassName } from './utils'
import { columns } from './constants'
import { BTN_TXT } from '../../../../../constants'
import { ReactComponent as Edit16 } from '../../../../../assets/svg/Edit16.svg'
import { LedByCommunityGroup, LedByCommunityTableProps } from './types'
import './styles.scss'
import { useSplitFeesPopup } from '../../../SplitFees/Providers/SplitFeesPopupProvider'
import { useSelector } from 'react-redux'
import { getUser } from '../../../../../redux/store/user/getters'
import { ACTIONS, defineAbility, SUBJECTS } from '../../../Abilities'

export const LedByCommunityTable = ({
  relations,
  communityGPOId
}: LedByCommunityTableProps) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const {
    editLedByCommunityPopup: { actions }
  } = useSplitFeesPopup()

  const [selectedRows, setSelectedRows] = useState<LedByCommunityGroup[]>([])

  const user = useSelector(getUser)
  const ability = defineAbility(user)
  const canEditLedByGPOTable = ability.can(
    ACTIONS.EDIT,
    SUBJECTS.ADMIN_SPLIT_FEES
  )

  const tableData = useMemo(
    () => formatTableData(relations, communityGPOId),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [relations]
  )

  const handleSelectRow = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys)
    setSelectedRows(selectedRows)
  }

  const onResetSelection = () => {
    setSelectedRowKeys([])
    setSelectedRows([])
  }

  useEffect(() => {
    onResetSelection()
  }, [relations])

  return (
    <div className="table-wrapper community-table column gap-16 p-24">
      <Typography.Headline6 className="community-table__title">
        Admin split fees
      </Typography.Headline6>
      {!!selectedRowKeys.length && (
        <div className="table-wrapper__header">
          <Typography.Body1
            className="table-wrapper__select-title"
            weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}
          >
            Selected {selectedRowKeys.length} of {tableData.length}
          </Typography.Body1>
          <div className="table-wrapper__header-buttons">
            <Button
              onClick={onResetSelection}
              type={BUTTON_TYPES.DEFAULT}
              upperCase
            >
              {BTN_TXT.CANCEL}
            </Button>
            <Button
              type={BUTTON_TYPES.PRIMARY}
              icon={<Edit16 />}
              onClick={() => actions.open({ selectedRows })}
              upperCase
            >
              {BTN_TXT.EDIT_FEES}
            </Button>
          </div>
        </div>
      )}
      <Table<LedByCommunityGroup>
        dataSource={tableData}
        columns={columns}
        rowClassName={(record) => getRowClassName(record, canEditLedByGPOTable)}
        rowSelection={
          canEditLedByGPOTable
            ? {
                selectedRowKeys,
                onChange: handleSelectRow,
                getCheckboxProps: (record) => ({
                  disabled:
                    !!selectedRowKeys.length &&
                    !selectedRowKeys.includes(record.key as never)
                })
              }
            : undefined
        }
      />
    </div>
  )
}
